import { useControl } from "@essenza/react";
import { Button, Col, List, Row } from "antd";
import { EditOutlined } from '@ant-design/icons';
import { JobModel } from "../models/jobmodel";
import { JobService } from "../service/JobService";

function JobListController(c) {
    c.skin = JobList;
    c.command = {
        CLOSE: (job, { node, model }) => {
            const item = { id: job.id };
            node.etype = "joboffer";
            node.mutate("istatus", 2, item);
            node.mutate("ctime", new Date(), item);
            node.save().then(() => {
                c.request(JobService, s => s.notify({ type: "C", title: job.title, company: c.app.session.tbusinessname }));
                //model.read(JobModel, m => m.Active());
                node.remove(job.id);
                c.navigate("/chiuse")
            }); //Oppure rimuovo da lista
        }
    }
}

export function JobList({ source, closed }) {
    const [control] = useControl(JobListController);
    if (!source.data) return null;
    return (
        <>
            <div className="" style={{ padding: '24px' }}>
                <List dataSource={source.getCollection()}
                    renderItem={job => (
                        <List.Item>
                            <div className="w100 padding-md bg-pri round-sm shadow-hx" style={{ textAlign: 'left' }}>
                                <Row className="w100">
                                    <Col flex="auto">
                                        <h2>{job.title}</h2>
                                    </Col>
                                    <Col flex="none" onClick={() => control.navigate("/offerta", job)} className="pointer">
                                        <EditOutlined />
                                    </Col>
                                </Row>
                                <Row className="w100 py-md">
                                    <Col span={8}>
                                        <p>Pubblicata il {new Date(job.idate).toLocaleString("it-IT").substring(0,10)}</p>
                                    </Col>
                                    <Col span={16}>
                                        <h5>{job.count} Candidati</h5>
                                    </Col>
                                </Row>
                                <Row className="w100">
                                    <Col flex="auto">
                                        <Button onClick={() => control.navigate("/candidati", job)} className="primaryButton">
                                            Visualizza Candidati
                                        </Button>
                                    </Col>
                                    {!closed && <Col flex="none">
                                        <Button onClick={() => control.execute("CLOSE", job, source)} className="secondaryButton">
                                            Chiudi l'offerta
                                        </Button>
                                    </Col>}
                                </Row>
                            </div>
                        </List.Item>
                    )}
                />
            </div>
        </>
    )
}